<template lang="pug">
  span
    v-menu(v-model="showMenu" rounded="lg" allow-overflow attach :close-on-content-click="false" offset-y max-height="420" min-width="320" max-width="600" nudge-bottom="8" z-index="11")
      template(v-slot:activator="{ on, attrs }")
        v-btn.px-2.button-text-normal.button-filter.text-none(v-if="currentCollectedKey" outlined rounded height="28" v-bind="attrs" v-on="on")
          v-icon.mr-1(@click.stop="clear" size=13) $yzi-x-circle
          .text-xs.font-semibold {{ $t('available') }} {{ loyaltySystem }}
          .px-1.neutral400--text |
          .text-xs.primary--text.font-medium {{ selectedCollectedValueDisplay }}
          v-icon.ml-1(size=16) $yzi-chevron-down
        v-btn.px-2.button-text-normal.border-dashed.button-filter(v-else outlined rounded height="28" v-bind="attrs" v-on="on")
          v-icon.mr-1(size=13) $yzi-plus-circle
          .text-xs.text-none.font-semibold {{ $t('available') }} {{ loyaltySystem }}
      // Filter list
      .white
        .font-semibold.text-sm.pa-4 {{ $t('filter_by') }} {{ $t('available').toLowerCase() }} {{ loyaltySystem }}
        v-radio-group.mx-0.mt-0(v-model="selectedCollectedKey")
          template(v-for="collectedKey in availableCollectedKeys")
            v-radio.px-4(:value="collectedKey" :key="`collected-key-${collectedKey.value}`")
              template(v-slot:label)
                .text-sm.font-normal.primary--text {{ collectedKey.label }}...
            template(v-if="selectedCollectedKey && selectedCollectedKey.value === collectedKey.value")
              v-text-field.round-lg.px-4.mb-4(v-if="selectedCollectedKey.value !== 'between'" v-model.number="selectedValue" outlined dense type="number" :placeholder="valuePlaceholder" hide-details="auto")
              .d-flex.align-center(v-else)
                v-text-field.round-lg.px-4(v-model.number="selectedValueFrom" outlined dense type="number" :placeholder="valuePlaceholder" hide-details="auto")
                .text-sm.font-normal.primary--text {{ $t('and') }}
                v-text-field.round-lg.px-4(v-model.number="selectedValueTo" outlined dense type="number" :placeholder="valuePlaceholder" hide-details="auto")
      // Actions
      .bottom-0.sticky.z-1.white
        .d-flex.align-center.px-4.py-3.border-t
          .text-sm.font-semibold.underline.normal-case.neutral700--text.cursor-pointer(v-if="!disabledClear" @click="clear") {{ $t('clear') }}
          v-spacer
          v-btn.button-sm(@click="apply" color="primary" depressed :disabled="disabledApply") {{ $t('apply') }}
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
  props: ['filter', 'loyaltySystem'],
  data() {
    return {
      showMenu: false,
      searchText: '',
      currentCollectedKey: null,
      selectedCollectedKey: null,
      valuePlaceholder: `${this.$t('insert_value')} (${this.$t('number').toLowerCase()})`,
      selectedValue: null,
      currentValue: null,
      selectedValueFrom: null,
      currentValueFrom: null,
      selectedValueTo: null,
      currentValueTo: null
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    disabledApply() {
      if (this.selectedCollectedKey === null) return true

      if (this.currentCollectedKey) return this.currentCollectedKey === this.selectedCollectedKey

      return false
    },
    disabledClear() {
      return this.selectedCollectedKey === null
    },
    selectedCollectedValueDisplay() {
      if (!this.currentCollectedKey) return null

      let value = this.currentValue
      if (this.currentCollectedKey.value === 'between') value = `${this.currentValueFrom} to ${this.currentValueTo}`
      return `${this.currentCollectedKey.label} ${value}`
    },
    availableCollectedKeys() {
      const collectedKeys = [
        {
          label: this.$t('more_than'),
          value: 'collected__gt'
        },
        {
          label: this.$t('less_than'),
          value: 'collected__lt'
        },
        {
          label: this.$t('equals_to'),
          value: 'collected'
        },
        {
          label: this.$t('between'),
          value: 'between'
        }
      ]
      if (this.loyaltySystem === 'stamps') {
        collectedKeys.push({
          label: this.$t('last_stamps_before_reward'),
          value: 'to_next_reward'
        })
      }
      return collectedKeys
    }
  },
  watch: {
    filter: {
      handler() {
        if (!this.filter.key) {
          this.clearData()
        }
      }
    },
    showMenu(value) {
      if (value && this.currentCollectedKey) {
        this.selectedCollectedKey = {...this.currentCollectedKey}
        if (this.currentCollectedKey.value === 'between') {
          this.selectedValueFrom = this.currentValueFrom
          this.selectedValueTo = this.currentValueTo
          this.selectedValue = null
          this.currentValue = null
          return
        }
        this.selectedValue = this.currentValue
        this.selectedValueFrom = null
        this.currentValueFrom = null
        this.selectedValueTo = null
        this.currentValueTo = null
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    clear() {
      this.clearData()
      this.$emit('update:filter', {})
    },
    clearData() {
      this.currentCollectedKey = null
      this.selectedCollectedKey = null
      this.selectedValue = null
      this.currentValue = null
      this.selectedValueFrom = null
      this.currentValueFrom = null
      this.selectedValueTo = null
      this.currentValueTo = null
    },
    apply() {
      this.showMenu = false
      this.currentCollectedKey = {...this.selectedCollectedKey}
      this.currentValue = this.selectedValue
      this.currentValueFrom = this.selectedValueFrom
      this.currentValueTo = this.selectedValueTo
      const key = this.selectedCollectedKey.value
      const value = this.selectedValue
      if (this.selectedCollectedKey.label === this.$t('between')) {
        return this.$emit('update:filter',
            {
              key,
              value: [
                {
                  key: 'collected__gte', value: this.selectedValueFrom
                },
                {
                  key: 'collected__lte', value: this.selectedValueTo
                }
              ]
            }
        )
      }
      this.$emit('update:filter', {key, value})
    }
  }
}
</script>

<style lang="scss" scoped>
.button-filter {
  min-width: 0 !important;
  color: #848484;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>